/*
 * rheincool — Betriebskosten-Block auf der PDP (Produktdetail-Handoff §10)
 *
 * EINE Preisquelle: rc-constants (settings.rc_energy_price_ct), dieselbe wie
 * im Ratgeber-Stromrechner. Rechenweg analog zum Rechner, nur mit dem echten
 * SEER des Geräts statt Klassenfaktor: Aufnahme = kW / SEER.
 * €/h = Aufnahme × Preis · €/Tag = €/h × Stunden · €/Sommer = €/Tag × Sommertage.
 */
class RcRunningCosts extends HTMLElement {
  connectedCallback() {
    let constants = {};
    try {
      constants = JSON.parse(document.getElementById('rc-constants').textContent);
    } catch {
      return;
    }
    const kw = parseFloat(this.dataset.kw);
    const seer = parseFloat(this.dataset.seer);
    const hours = parseFloat(this.dataset.hours) || 6;
    if (!kw || !seer) return;

    const priceCt = typeof constants.energyPriceCtKwh === 'number' ? constants.energyPriceCtKwh : 35;
    const sommerTage = typeof constants.sommerTage === 'number' ? constants.sommerTage : 90;

    const eurHour = (kw / seer) * (priceCt / 100);
    const eurDay = eurHour * hours;
    const eurSummer = eurDay * sommerTage;

    const fmt = (value, digits) =>
      new Intl.NumberFormat('de-DE', {
        minimumFractionDigits: digits,
        maximumFractionDigits: digits,
      }).format(value);

    const set = (selector, text) => {
      const el = this.querySelector(selector);
      if (el) el.textContent = text;
    };
    set('[data-costs-hour]', `${fmt(eurHour, 2)} €`);
    set('[data-costs-day]', `${fmt(eurDay, 2)} €`);
    set('[data-costs-summer]', `${fmt(Math.round(eurSummer), 0)} €`);

    const assumption = this.querySelector('[data-costs-assumption]');
    if (assumption && this.dataset.assumptionTemplate) {
      let text = this.dataset.assumptionTemplate
        .replace('[stunden]', fmt(hours, 0))
        .replace('[preis]', fmt(priceCt, 0))
        .replace('[tage]', fmt(sommerTage, 0));
      if (constants.energyPriceStand && this.dataset.standTemplate) {
        text += ` ${this.dataset.standTemplate.replace('[stand]', constants.energyPriceStand)}`;
      }
      assumption.textContent = text;
    }

    // Ersparnis-Hinweis (nur A++/A+++): gleiche Formel (kW / SEER), als
    // Referenz die SEER-Untergrenze der Klasse A+ (5,6) — konservativ.
    const hint = this.querySelector('[data-costs-hint]');
    if (hint && this.dataset.hintTemplate) {
      const apSummer = (kw / 5.6) * hours * sommerTage * (priceCt / 100);
      const saving = apSummer - eurSummer;
      if (saving >= 5) {
        hint.textContent = this.dataset.hintTemplate
          .replace('[klasse]', this.dataset.energyClass || 'A++')
          .replace('[betrag]', fmt(Math.round(saving), 0));
        hint.hidden = false;
      }
    }
  }
}

customElements.define('rc-running-costs', RcRunningCosts);
